let lastKeyword = "";
let lastHTML = "";

document.addEventListener("input", function(e){

  if(!e.target.matches('.search__input')) return;

  let box = document.getElementById("search-suggest");

  if(!box){
    box = document.createElement("div");
    box.id = "search-suggest";
    e.target.closest(".field").appendChild(box);
  }

  const keyword = e.target.value.trim();
  lastKeyword = keyword;

  if(keyword.length < 2){
    box.innerHTML = "";
    return;
  }

  clearTimeout(window.searchTimer);

  window.searchTimer = setTimeout(()=>{

    fetch(`/search?q=${encodeURIComponent(keyword)}&view=suggest&type=product`)
    .then(r=>r.text())
    .then(html => {

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const results = doc.querySelector("#search-suggest-results");

      if(results){
        lastHTML = results.innerHTML;
        box.innerHTML = lastHTML;
      }

    });

  },200);

});


document.addEventListener("click", function(e){

  const box = document.getElementById("search-suggest");
  const search = document.querySelector(".search__input");

  if(!box || !search) return;

  if(!search.contains(e.target) && !box.contains(e.target)){
    box.innerHTML = "";
  }

});


document.addEventListener("focusin", function(e){

  if(!e.target.matches('.search__input')) return;

  const box = document.getElementById("search-suggest");
  if(!box) return;

  const keyword = e.target.value.trim();
  if(!keyword) return;

  // キャッシュがあれば即表示
  if(lastHTML){
    box.innerHTML = lastHTML;
    return;
  }

  // 無ければ再取得
  fetch(`/search?q=${encodeURIComponent(keyword)}&view=suggest&type=product`)
  .then(r=>r.text())
  .then(html => {

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const results = doc.querySelector("#search-suggest-results");

    if(results){
      lastHTML = results.innerHTML;
      box.innerHTML = lastHTML;
    }

  });

});
